var rtlStyles = {"rtl":"_02zcL","ltr":"vC2ou"};

export { rtlStyles as r };
//# sourceMappingURL=rtl.rtlignore-09de95fb.js.map
